import React from 'react';
import { Col } from 'react-bootstrap';
import { ReactComponent as ProgressBarTruckIcon } from 'src/Images/icons/common/progressBarTruckIcon.svg';
import { ReactComponent as Pointer } from 'src/Images/icons/common/pointer.svg';
import TruckXs from 'src/Images/icons/truck/truck-xs.png';
import TruckSm from 'src/Images/icons/truck/truck-sm.png';
import TruckMd from 'src/Images/icons/truck/truck-md.png';
import TruckLg from 'src/Images/icons/truck/truck-lg.png';
import TruckXl from 'src/Images/icons/truck/truck-xl.png';
import { ReactComponent as ArrowRight } from 'src/Images/icons/common/arrowright.svg';
import { ReactComponent as ArrowLeft } from 'src/Images/icons/common/arrowleft.svg';
import { useNavigate } from 'react-router-dom';

function VehicleTypeListForDashboard({
  vehicles,
  scrollRef,
  getProgress,
  isMobile,
  themeColor,
  BorderLinearProgress,
  StationOverviewEmpty,
  scrollLeft,
  scrollRight,
  selectedWorkflowStageId,
  containerClass,
  stageFrom,
  stageTo,
  timeFrom,
  timeTo,
  emptyMessage,
  statusLabel,
}) {
  const navigate = useNavigate();

  const getTruckImage = (type) => {
    switch (type) {
      case '1':
        return TruckXs;
      case '2':
        return TruckSm;
      case '3':
        return TruckMd;
      case '4':
        return TruckLg;
      default:
        return TruckXl;
    }
  };

  const statusStyles = {
    'On time': {
      pillClass: 'card-green-pill',
      pointerColor: '#0E9A26',
    },
    'In progress': {
      pillClass: 'card-orange-pill',
      pointerColor: '#ff8a32',
    },
    Delayed: {
      pillClass: 'card-red-pill',
      pointerColor: '#e7332f',
    },
  };

  const { pillClass, pointerColor } = statusStyles[statusLabel] || {};

  return (
    <div className="div-flex-row div-align-center cg-10">
      {vehicles.length > 0 ? (
        <>
          {!isMobile && (
            <button
              className="icon-btn-none"
              onClick={() => scrollLeft(scrollRef)}
              type="button"
              aria-label="Arrow left"
            >
              <ArrowLeft className="icon-size-xxl arrow-button" />
            </button>
          )}

          <div
            ref={scrollRef}
            className={
              isMobile
                ? `div-flex-column rg-20 incoming-vehicle-container-mobile-height theme-vertical-scrollable-container-${themeColor}`
                : `div-flex-row cg-20 hide-scrollbar theme-horizontal-scrollable-container-${themeColor} w-100`
            }
          >
            {vehicles.map((vehicle) => {
              const progress = getProgress(
                vehicle[stageFrom]?.[timeFrom],
                vehicle[stageTo]?.[timeTo],
              );

              return (
                <Col key={vehicle.vehicle_tracking_code} xxl={2} xl={3} lg={4}>
                  <div
                    className={`incoming-vehicle-card ${isMobile ? '' : 'border-bottom'}`}
                  >
                    <div className={`${containerClass} div-flex-column`}>
                      <div
                        tabIndex={0}
                        role="button"
                        onClick={() =>
                          navigate(
                            `/${selectedWorkflowStageId || 1}/${vehicle.vehicle_tracking_number}`,
                          )
                        }
                        className="text-semi-bold text-lg vertical-padding-5 horizontal-padding-10 w-100"
                      >
                        <span className="text-hover-underline">
                          {vehicle.vehicle_tracking_code}
                        </span>
                      </div>

                      <div className="horizontal-padding-10 vertical-padding-10 bg-white div-flex-row div-space-between">
                        <img
                          src={getTruckImage(vehicle.vehicle_type)}
                          alt="truck"
                          className="incoming-vehicle-image"
                        />

                        <div className="div-flex-end">
                          <div className="div-flex-column div-align-end div-align-center rg-10">
                            <div className="div-flex-column div-align-end">
                              <span className="text-sm text-semi-bold text-grey">
                                {vehicle.workflow_stage_name}
                              </span>
                              <span className="text-lg text-bold text-nowrap">
                                {vehicle.transaction_time}
                              </span>
                            </div>

                            <div
                              className={`div-flex-row cg-5 ${pillClass} div-align-center`}
                            >
                              <Pointer
                                className="icon-size-xxs"
                                color={pointerColor}
                              />
                              <span className="text-sm text-semi-bold">
                                {statusLabel}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="incoming-progress-section bg-white horizontal-padding-10 vertical-padding-10">
                        <div className="div-flex-row div-space-between text-sm text-semi-bold text-grey padding-bottom-10">
                          <span>{vehicle[stageFrom]?.stage_name || '-'}</span>
                          <span>{vehicle[stageTo]?.stage_name || '-'}</span>
                        </div>

                        <div
                          className="progress-container"
                          style={{
                            '--progress-left': `calc(${progress}% - 14px)`,
                          }}
                        >
                          <BorderLinearProgress
                            variant="determinate"
                            value={progress}
                          />
                          <ProgressBarTruckIcon className="progress-truck-icon" />
                        </div>

                        <div className="div-flex-row div-space-between text-sm text-semi-bold text-grey padding-top-10">
                          <span>{vehicle[stageFrom]?.[timeFrom] || '-'}</span>
                          <span>{vehicle[stageTo]?.[timeTo] || '-'}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              );
            })}
          </div>

          {!isMobile && (
            <button
              className="icon-btn-none"
              onClick={() => scrollRight(scrollRef)}
              type="button"
              aria-label="Arrow right"
            >
              <ArrowRight className="icon-size-xxl arrow-button" />
            </button>
          )}
        </>
      ) : (
        <div className="div-flex-column incoming-vehicle-card-empty div-flex-center div-align-center rg-10 w-100">
          <StationOverviewEmpty />
          <span className="text-sm text-grey">{emptyMessage}</span>
        </div>
      )}
    </div>
  );
}

export default VehicleTypeListForDashboard;
